import { helpers } from "vuelidate/lib/validators";

export const passwordRegex = (value: string) =>
  !helpers.req(value) || passwordPattern(value);

function passwordPattern(value: string) {
  return new RegExp(/^[A-Za-z0-9 .,!?_-]{8,}$/, "g").test(value);
}
